import RpsHeader from './RpsHeader';
import RpsTogglerButton from './RpsTogglerButton';
import './RpsStickyHeader'

customElements.define('rps-header', RpsHeader);
customElements.define('rps-toggler-button', RpsTogglerButton);
